import { render } from "./ArticlePreview.vue?vue&type=template&id=20a09f4d&scoped=true&ts=true"
import script from "./ArticlePreview.vue?vue&type=script&lang=ts"
export * from "./ArticlePreview.vue?vue&type=script&lang=ts"

import "./ArticlePreview.vue?vue&type=style&index=0&id=20a09f4d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a09f4d"]])

export default __exports__